import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

import AdatisLogo from '../Components/Common/AdatisLogo';
import SearchOption from '../Components/Common/SearchOption';
import HelpMenuDropdown from '../Components/Common/HelpMenuDropdown';
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import WebAppsDropdown from '../Components/Common/WebAppsDropdown';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import SuperAdminNotificationDropdown from '../Components/Common/SuperAdminNotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import SuperAdminProfileDropdown from '../Components/Common/SuperAdminProfileDropdown';

import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import {
    TENANT_SIDEBAR_SIZE,
    VERTICAL_SIDEBAR_MOBILE_MAX_PX,
} from '../helpers/layout_defaults';

const Header = ({ headerClass }: { headerClass?: string }) => {
    const { t } = useTranslation();
    const dispatch : any = useDispatch();
    const location = useLocation();
    const isSuperAdminArea =
        location.pathname.startsWith("/super-admin") &&
        location.pathname !== "/super-admin/login";
    const headerHomePath = isSuperAdminArea ? "/super-admin/dashboard" : "/";

    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
      );
    const sidebarVisibilitytype = useSelector(selectDashboardData);

    const [search, setSearch] = useState<boolean>(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        const windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement | null;
        const dataLayout = document.documentElement.getAttribute("data-layout");
        const isMobile = windowSize <= VERTICAL_SIDEBAR_MOBILE_MAX_PX;

        dispatch(changeSidebarVisibility("show"));

        if (humberIcon && !isMobile) {
            humberIcon.classList.toggle("open");
        }

        if (dataLayout === "horizontal") {
            document.body.classList.toggle("menu");
        }

        // Mobile: drawer overlay (ADJ-F1-121 / BUG-F1-173) — labels always visible inside drawer.
        if (isMobile) {
            document.body.classList.toggle("vertical-sidebar-enable");
            document.documentElement.setAttribute("data-sidebar-size", TENANT_SIDEBAR_SIZE);
            return;
        }

        // Desktop + tablet: toggle expanded (lg / ícone+nome) ↔ compact (sm); never blank size.
        if (
            sidebarVisibilitytype === "show" &&
            (dataLayout === "vertical" || dataLayout === "semibox")
        ) {
            document.body.classList.remove("vertical-sidebar-enable");
            const current = document.documentElement.getAttribute("data-sidebar-size");
            document.documentElement.setAttribute(
                "data-sidebar-size",
                current === "sm" ? TENANT_SIDEBAR_SIZE : "sm"
            );
        }

        if (dataLayout === "twocolumn") {
            document.body.classList.toggle("twocolumn-panel");
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to={headerHomePath} className="logo logo-dark">
                                    <span className="logo-sm">
                                        <AdatisLogo variant="sm" linkTo={false} />
                                    </span>
                                    <span className="logo-lg">
                                        <AdatisLogo variant="menu" linkTo={false} />
                                    </span>
                                </Link>

                                <Link to={headerHomePath} className="logo logo-light">
                                    <span className="logo-sm">
                                        <AdatisLogo variant="sm" linkTo={false} />
                                    </span>
                                    <span className="logo-lg">
                                        <AdatisLogo variant="menu" linkTo={false} />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>

                            {!isSuperAdminArea ? <SearchOption /> : null}
                        </div>

                        <div className="d-flex align-items-center">

                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('header.search.placeholder')}
                                                    aria-label={t('header.search.placeholder')}
                                                />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            <LanguageDropdown />

                            {!isSuperAdminArea ? <HelpMenuDropdown /> : null}

                            {!isSuperAdminArea ? <WebAppsDropdown /> : null}

                            <FullScreenDropdown />

                            {!isSuperAdminArea ? <NotificationDropdown /> : null}
                            {isSuperAdminArea ? <SuperAdminNotificationDropdown /> : null}

                            {isSuperAdminArea ? (
                                <SuperAdminProfileDropdown />
                            ) : (
                                <ProfileDropdown />
                            )}
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
